import { SBoxInner } from "../../../style/contents/backup/backup";

interface ModalProps {
  closedHandler: () => void;
  txt: string;
}

const AlertModal = ({ closedHandler, txt }: ModalProps) => {
  return (
    <SBoxInner className="alert">
      <div className="modal-header">
        <p>알림</p>
        <button onClick={closedHandler} className="closed-modal-btn">
          <img src="/assets/Close_Icons_UIA.svg" alt="" />
        </button>
      </div>
      <div className="modal-body">
        <p>{txt}</p>
        <div className="btn-box">
          <button onClick={closedHandler}>닫기</button>
        </div>
      </div>
    </SBoxInner>
  );
};

export default AlertModal;
